"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var quick_exit_1 = require("quick-exit");
document.addEventListener('alpine:init', function () {
    Alpine.data('quickExit', function () {
        return {
            popupOpen: false,
            init: function () { },
            openPopup: function () {
                if (this.$store.app.md) {
                    this.popupOpen = true;
                }
            },
            exit: function () {
                (0, quick_exit_1.default)();
                this.$store.app.track({
                    event: 'quick-exit',
                    type: 'click',
                    trigger: 'exit',
                    module: 'quick-exit',
                    data: {},
                });
            },
        };
    });
});
